import { jsx as _jsx, jsxs as _jsxs } from "@fluentui/react-jsx-runtime/jsx-runtime";
import { assertSlots } from '@fluentui/react-components';
/**
 * Render the final JSX of UserMessage
 */
export const renderUserMessage_unstable = state => {
  assertSlots(state);
  return /*#__PURE__*/_jsxs(state.root, {
    children: [state.accessibleHeading && /*#__PURE__*/_jsx(state.accessibleHeading, {}), state.root.children]
  });
};
//# sourceMappingURL=renderUserMessage.js.map